import { useGetAdFormIntegrations } from '../api/queries/useGetAdFormIntegrations.js';
import { useGetAppsFlyerIntegrations } from '../api/queries/useGetAppsFlyerIntegrations.js';
import { useGetCampaignManagerIntegrations } from '../api/queries/useGetCampaignManagerIntegrations.js';
import { useGetGAIntegrations } from '../api/queries/useGetGAIntegrations.js';
import { type CmIntegrations } from '../schemas/integrations.js';
import { useIntegrationLayoutRouteApi } from './useIntegrationsRouteApi.js';

export const useAllIntegrations = () => {
  const { integration: routeIntegration } =
    useIntegrationLayoutRouteApi().useParams();

  const integration =
    routeIntegration === 'ga4' ? 'google_analytics' : routeIntegration;

  const { data: adFormIntegrations, isLoading: adFormLoading } =
    useGetAdFormIntegrations({
      enabled: integration === 'adform_ad_server',
    });

  const {
    data: campaignManagerIntegrations,
    isLoading: campaignManagerLoading,
  } = useGetCampaignManagerIntegrations({
    enabled: integration === 'campaign_manager',
  });

  const { data: appsflyerIntegrations, isLoading: appsflyerLoading } =
    useGetAppsFlyerIntegrations({
      enabled: integration === 'appsflyer',
    });
  const {
    data: googleAnalyticsIntegrations,
    isLoading: googleAnalyticsLoading,
  } = useGetGAIntegrations({
    enabled: integration === 'google_analytics',
  });

  const campaignManagerIntegrationsList =
    (campaignManagerIntegrations as CmIntegrations)?.integrations || [];

  return {
    adform_ad_server: adFormIntegrations?.integrations || [],
    adform: adFormIntegrations?.integrations || [],
    campaign_manager: campaignManagerIntegrationsList,
    appsflyer: appsflyerIntegrations?.items || [],
    google_analytics: googleAnalyticsIntegrations?.items || [],
    loading: {
      adform_ad_server: adFormLoading,
      adform: adFormLoading,
      campaign_manager: campaignManagerLoading,
      appsflyer: appsflyerLoading,
      google_analytics: googleAnalyticsLoading,
    } as { [key: string]: boolean },
  };
};
